import React, { FC } from 'react'

import styled from 'styled-components'

import { Txt } from 'src/components/atoms'

const Container = styled.ul`
  display: grid;
  grid-template-columns: 60px repeat(5, 48px) 60px;
  justify-items: center;
`

type Props = {
  className?: string
}

export const CalendarWeekday: FC<Props> = ({ className }) => {
  const days = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU']

  return (
    <div className={className}>
      <Container>
        {days.map(day => (
          <li
            key={day}
            className={day === 'SU' ? 'tw-pr-[12px]' : day === 'MO' ? 'tw-pl-[12px]' : ''}
          >
            <Txt
              fontType="alphabet"
              sizeType="s"
              className={`tw-font-light
               ${day === 'SA' ? 'tw-text-pattern2-2' : day === 'SU' ? 'tw-text-pattern2-1' : ''}
              `}
            >
              {day}
            </Txt>
          </li>
        ))}
      </Container>
    </div>
  )
}
